if(window.innerWidth < 991) {
    $('.why-flooret .cards-wrap').slick({
          dots: true,
          arrows:false,
          infinite: false,
           autoplay: true,
          autoplaySpeed: 5000,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
  
    $('.sustainable ul').slick({
          dots: true,
          arrows:false,
          infinite: false,
           autoplay: true,
          autoplaySpeed: 5000,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

  $('.featured-projects .main-b-sec').slick({
          dots: true,
          arrows:false,
          infinite: false,
           autoplay: true,
          autoplaySpeed: 5000,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

      $('.systainability-section .card__wrap').slick({
          dots: true,
          arrows:false,
          infinite: false,
           autoplay: true,
          autoplaySpeed: 5000,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
  }

if(window.innerWidth < 991 && window.innerWidth > 768) {
    $('.next-project-form .card-wrap').slick({
          dots: true,
          arrows:false,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1
        });
}
    $('.get-started ul').slick({
          dots: false,
          arrows:true,
          infinite: false,
          //  autoplay: true,
          // autoplaySpeed: 5000,
          // initialSlide: 1,
          speed: 500,
          centerMode: true,
          centerLeft:'150px',
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
});

$('.testimonial-wrap').slick({
          dots: false,
          arrows:true,
          infinite: false,
          //  autoplay: true,
          // autoplaySpeed: 5000,
          // initialSlide: 1,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          
});




// var plankType = document.querySelector('.filter-group--plank-type')
// var glueDown = `<li id="plank_input" value="gid-shopify-metaobject-148178895084"
// class="filter-option--gid-shopify-metaobject-148178895084">
// <input type="checkbox" id="filter.p.m.custom.plank_type-2" class="hidden" name="filter.p.m.custom.plank_type"
// value="gid://shopify/Metaobject/148178895084">
// <label class="col-facets__item" title="Glue-Down" for="filter.p.m.custom.plank_type-2"><span
//   class="col-facets__label">Glue-Down <span class="count">(1)</span></span>
//   </label>
//   </li>`;
// if(plankType) {
//   plankType.insertAdjacentHTML('beforeend', glueDown);
// }


document.addEventListener('DOMContentLoaded', ()=>{
    var a = document.querySelector('#prevBtn');
    if(a){
      a.addEventListener('click', ()=>{
          document.querySelector('.get-started .slick-prev').click();
      })
    }
    var b = document.querySelector('#nextBtn');
    if(b){
      b.addEventListener('click', ()=>{
          document.querySelector('.get-started .slick-next').click();
      })
    }
})

document.addEventListener('DOMContentLoaded', ()=>{
    var c = document.querySelector('#prevBtnDesigner');
    if(c){
      c.addEventListener('click', ()=>{
          document.querySelector('.designer-section .slick-prev').click();
      })
    }
    var d = document.querySelector('#nextBtnDesigner');
    if(d){
      d.addEventListener('click', ()=>{
          document.querySelector('.designer-section .slick-next').click();
      })
    }
})


